import React, { useContext, useEffect, useState } from 'react';
import { db } from 'src/firebase';
import { collection, getDocs, query } from 'firebase/firestore';
import { Pane, Text, Card, DocumentOpenIcon, Heading, Button, ArrowRightIcon, Tooltip, Position } from 'evergreen-ui';
import { Loading } from 'src/components';
import { useNavigate } from 'react-router-dom';
import AuthContext from 'src/providers/authProvider';
import useRedirectIfNotAuthorized from 'src/hooks/useIsAdminWithRedirect';
import Layout from 'src/layouts/Default';
import '../styles.css';

const sortEventsDesc = (a, b) => {
    const aTimestamp = a.timestamp;
    const bTimestamp = b.timestamp;
    
    if (aTimestamp && bTimestamp) {
        return bTimestamp - aTimestamp;
    }

    if (!aTimestamp && bTimestamp) {
        return -1;
    }

    if (aTimestamp && !bTimestamp) {
        return 1;
    }

    return 0;
};

const EmailTracking = () => {
  const navigate = useNavigate();
  const { loading } = useContext(AuthContext);
  useRedirectIfNotAuthorized();
  const [events, setEvents] = useState([]);
  const [areEventsLoading, setAreEventsLoading] = useState(true);
  const getEvents = async () => {
    const q = await query(collection(db, 'emailTracking'));
    const snapshot = await getDocs(q);
    const newEvents = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
    newEvents.sort(sortEventsDesc);
    setEvents(newEvents);
    setAreEventsLoading(false);
  };

  useEffect(() => {
    getEvents();
  }, []);

  if (loading || areEventsLoading) {
    return <Loading />;
  }

  const onGoBack = () => {
    window.history.back();
  };

  const convertTimestamp = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleString();
  };

  return (
    <Layout title="Email Tracking" actionButtonProps={{ onBack: onGoBack }} maxWidth={720}>
      <Card elevation={1} padding="30px" width={540} maxWidth="100%" display="flex" flexDirection="column" gap="24px" wordBreak="break-all">
        {events.map((event, idx) => (
          <>
            <Pane key={event.id} display="flex" alignItems="center" gap="14px" cursor="pointer">
              <Tooltip content="Email opened" position={Position.TOP}>
                <DocumentOpenIcon size={24} />
              </Tooltip>
              <Pane display="flex" flexDirection="column">
                <Heading size={600}>{event.to}</Heading>
                <Text>{event.subject}</Text>
                {event.timestamp && <Text size={300}>{convertTimestamp(event.timestamp)}</Text>}
              </Pane>
              <Button marginLeft="auto" appearance="primary" onClick={() => navigate(`/admin/emails/${event.emailId}`)} iconAfter={ArrowRightIcon}>
                View Email
              </Button>
            </Pane>
            {idx < events.length - 1 && <Pane width="100%" height="1px" border="default" />}
          </>
        ))}
      </Card>
    </Layout>
  );
};

export default EmailTracking;
